import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

/** Shown wherever auth is required but VITE_CLERK_PUBLISHABLE_KEY is unset. */
export function ClerkNotConfigured() {
  return (
    <div className="mx-auto w-full max-w-xl px-6 py-16">
      <Card className="animate-page-enter">
        <CardHeader>
          <CardTitle>Auth not configured</CardTitle>
          <CardDescription>
            Set <code>VITE_CLERK_PUBLISHABLE_KEY</code> (frontend) and{" "}
            <code>CLERK_JWT_ISSUER_DOMAIN</code> / <code>CLERK_SECRET_KEY</code>{" "}
            (backend) to enable sign-in.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  );
}

export default ClerkNotConfigured;
